





































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { State } from "vuex-class";

import AliasedRequestProgressContainer from "@/components/ui/AliasedRequestProgressContainer.vue";

import { falconDocumentTypeFilter } from "@/filters/falcon/falcon-document-type.filter";
import { falconPaymentStatusFilter } from "@/filters/falcon/falcon-payment-status.filter";
import { capitalizeFilter } from "@/filters/capitalize.filter";

import { GetMyPaymentsPaymentListItem } from "@/interfaces/falcon/get-my-payments/get-my-payments-payment-list-item";

import { RequestAlias } from "@/enums/request-alias.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon payments table
 */
@Component({
  components: { AliasedRequestProgressContainer },
  filters: {
    ...falconDocumentTypeFilter,
    ...falconPaymentStatusFilter,
    ...capitalizeFilter
  }
})
export default class PaymentsTable extends Vue {
  @State(state => state.falconPayments.paymentsData)
  paymentsData!: GetMyPaymentsPaymentListItem[];
  requestAlias = RequestAlias.GetMyPayments;
  i18nMessageKeyEnum = I18nMessageKey;
}
